import './App.css';
import AppContainer from './views/containers';

function App() {
  return <AppContainer />;
}

export default App;
